import React, { useState } from 'react';
import './Coupons.scss';
import {http, AlertService, FxCurrency } from './../../fx-core';
export const Coupons = (props) => {
    const [manualCouponCode, setManualCouponCode] = useState('');

 // Helper already in your code:
const isCouponSelected = (coupon) => {
    return coupon && (coupon.id === props.selectedUserCouponId || coupon.id === props.selectedCouponId);
};

// 1) Click handler: don't toggle off if already selected
const handleCouponClick = (clickedCoupon) => {
    if (!clickedCoupon) return;

    // If already selected, do nothing (prevents toggle/deselect)
    if (isCouponSelected(clickedCoupon)) {
        // Optionally show feedback: AlertService.showInfoMsg('Coupon already applied');
        return;
    }

    // Otherwise apply the clicked coupon
    props.selectedCoupon(clickedCoupon);
};

// 2) Manual apply: if matched coupon is already selected, keep it selected
// const handleApplyManualCoupon = () => {
//     if (!manualCouponCode.trim()) return;

//     const matchedCoupon = props.couponList.find(
//         (coupon) =>
//             coupon.couponCode &&
//             coupon.couponCode.toLowerCase() === manualCouponCode.trim().toLowerCase()
//     );

//     if (matchedCoupon) {
//         // If the matched coupon is already the selected one, do nothing (keep it selected)
//         if (isCouponSelected(matchedCoupon)) {
//             setManualCouponCode('');
//             AlertService.showSuccessMsg('Coupon already applied.');
//             return;
//         }

//         // Otherwise apply/overwrite the coupon
//         props.selectedCoupon(matchedCoupon);
//         setManualCouponCode('');
//         AlertService.showSuccessMsg('Coupon applied successfully!');
//     } else {
//         AlertService.showErrorMsg('Invalid coupon code');
//     }
// };

const handleApplyManualCoupon = () => {
    if (!manualCouponCode.trim()) return;

    // First check local visible list
    const matchedCoupon = props.couponList.find(
        coupon => coupon.couponCode &&
            coupon.couponCode.toLowerCase() === manualCouponCode.trim().toLowerCase()
    );

    if (matchedCoupon) {
        if (isCouponSelected(matchedCoupon)) {
            setManualCouponCode('');
            AlertService.showSuccessMsg('Coupon already applied.');
            return;
        }
        props.selectedCoupon(matchedCoupon);
        setManualCouponCode('');
        AlertService.showSuccessMsg('Coupon applied successfully!');
        return;
    }

    // Not in visible list — call API for hidden coupons like FIRST100
    let apiOptions: any = {
        url: `coupon/stall/validate`,
        data: {
            couponCode: manualCouponCode.trim(),
            stallId: props.stallId
        }
    };
    http.post(apiOptions).then(res => {
        props.selectedCoupon(res.data);
        setManualCouponCode('');
        AlertService.showSuccessMsg('Coupon applied successfully!');
    }).catch(() => {
        AlertService.showErrorMsg('Invalid or expired coupon code');
    });
};

// 3) Remove: explicitly clear selection

const handleRemoveCoupon = () => { // Just deselect (pass the currently selected coupon to deselect it) 
if (props.selectedCouponId || props.selectedUserCouponId) { 
  // Find the currently selected coupon and pass it to deselect 
  const selectedCoupon = props.couponList.find( coupon => coupon.id === props.selectedUserCouponId || coupon.id === props.selectedCouponId ); if (selectedCoupon) { props.selectedCoupon(selectedCoupon);
     // This should deselect it 
     } } };

    // const isAnyCouponApplied = ! !props.selectedUserCouponId || !!props.selectedCouponId;

    return (
        <div className="coupon-container">
            {/* Header */}
            {props.couponList && props.couponList.length > 0 && (
                <div className="coupon-header">Apply Coupon</div>
            )}

            {/* Manual Coupon Input - Always Visible */}
            <div className="manual-coupon-input">
                <div className="input-group">
                    <input
                        type="text"
                        className="coupon-input"
                        placeholder="Enter coupon code"
                        value={manualCouponCode}
                        onChange={(e) => setManualCouponCode(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleApplyManualCoupon()}
                    />
                    <button
                        className="apply-btn"
                        onClick={handleApplyManualCoupon}
                        disabled={!manualCouponCode.trim()}
                    >
                        Apply
                    </button>
                </div>
            </div>

            {/* Available Coupons List */}
            {props.couponList.length > 0 && (
                <div className="coupon-list">
                    {props.couponList.map((coupon, i) => {
                        const isSelected = isCouponSelected(coupon);
                        
                        return (
                            <div key={i} className="coupon-item">
                                <button
                                    className={`coupon-btn ${isSelected ? 'coupon-btn-active' : ''}`}
                                    onClick={() => handleCouponClick(coupon)}
                                >
                                    <div className="coupon-content">
                                        <span className="coupon-code" title={coupon.couponCode}>
                                            {coupon.couponCode}
                                        </span>
                                        <span className="coupon-value">
                                            {coupon.couponValueTypeId === 1
                                                ? `${coupon.couponValue}% OFF`
                                                : coupon.couponValueTypeId === 2
                                                ? `₹${coupon.couponValue} OFF`
                                                : ''}
                                        </span>
                                    </div>
                                </button>

                                {/* Remove Button - Only show for selected coupon */}
                                {isSelected && (
                                    <button
                                        className="remove-btn"
                                        onClick={handleRemoveCoupon}
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            <style jsx>{`
                .coupon-container {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                .coupon-header {
                    font-size: 14px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 12px;
                    padding-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;
                }

                .manual-coupon-input {
                    background: #fff;
                    border: 1px solid #e8e8e8;
                    border-radius: 8px;
                    padding: 16px;
                    margin-bottom: 16px;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }

                .input-group {
                    display: flex;
                    gap: 8px;
                    align-items: center;
                }

                .coupon-input {
                    flex: 1;
                    height: 40px;
                    border: 1px solid #ddd;
                    border-radius: 6px;
                    padding: 0 12px;
                    font-size: 14px;
                    outline: none;
                    transition: border-color 0.2s ease;
                }

                .coupon-input:focus {
                    border-colvor: #f69516;
                    box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.1);
                }

                .apply-btn {
                    border: 1px solid #f69516;
                    background-color:#f69516;
                    color: white;
                    font-weight: 500;
                    height: 40px;
                    padding: 0 20px;
                    border-radius: 6px;
                    font-size: 14px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }

                .apply-btn:hover:not(:disabled) {
                    background-color: #f69516;
                    border-color: #f69516;
                }

                .apply-btn:disabled {
                    background-color: #ccc;
                    border-color: #ccc;
                    cursor: not-allowed;
                }

                .coupon-list {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .coupon-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 4px;
                }

                .coupon-btn {
                    flex: 1;
                    border: 1px solid #f69516;
                    background-color: white;
                    color: #f69516;
                    border-radius: 6px;
                    padding: 10px 12px;
                    font-weight: 500;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    height: 42px;
                }

                .coupon-btn-active {
                    background-color: #f69516;
                    color: white;
                }

                .coupon-btn:hover:not(.coupon-btn-active) {
                    background-color: #fff9f5;
                }

                .coupon-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                }

                .coupon-code {
                    font-weight: 600;
                    font-size: 13px;
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .coupon-value {
                    font-weight: 400;
                    font-size: 12px;
                }

                .coupon-btn .coupon-value {
                    color: #666;
                }

                .coupon-btn-active .coupon-value {
                    color: rgba(255, 255, 255, 0.9);
                }

                .remove-btn {
                    border: 1px solid #f69516;
                    color: #f69516;
                    background-color: #fff;
                    width: 32px;
                    height: 32px;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .remove-btn:hover {
                    background-color: #f69516;
                    color: white;
                }
            `}</style>
        </div>
    );
};